<template>
    <div class="data-container">
        <AttributesTable v-if="showAttributesTable" />
        <FeaturePopup />
        <Legends :isActive="showLegend" :isFixed="false" @onLegendAction="handleLegendAction" />

        <GeoprocessingChart v-if="showGeoChart" :key="geoChartTimestamp" :chartData="geoChartData"
            @close-chart="closeGeoChart" />
    </div>
</template>


<script>
import AttributesTable from './attributesTable/AttributesTable.vue';
import FeaturePopup from './select/FeaturePopup.vue';
import Legends from '@/components/mapControls/legends/Legends.vue';
import GeoprocessingChart from '@/components/mapTools/geoprocessings/GeoprocessingChart.vue';

export default {
    name: 'DataContainer',
    components: {
        AttributesTable,
        FeaturePopup,
        Legends,
        GeoprocessingChart
    },
    computed: {
        showAttributesTable() {
            return this.$store.getters["attributeTable/isVisible"];
        },
        showLegend() {
            const val = this.$store.state.mapControls.legends.active;
            console.log("DataContainer showLegend computed:", val);
            return val;
        },
        showGeoChart() {
            // Check if geoprocessing tool has emitted results
            const tool = this.$store.getters.getMapTools['geoprocessing'];
            console.log("📊 DataContainer showGeoChart check:", tool);
            return tool && tool.action === 'showResults' && tool.data && tool.data.chartData;
        },
        geoChartData() {
            const tool = this.$store.getters.getMapTools['geoprocessing'];
            return (tool && tool.data) ? tool.data.chartData : {};
        },
        geoChartTimestamp() {
            const tool = this.$store.getters.getMapTools['geoprocessing'];
            return (tool && tool.data) ? tool.data.timestamp : 0;
        }
    },
    methods: {
        handleLegendAction(component, action, payload) {
            if (action === 'exit') {
                this.$store.dispatch('setMapControlSelection', {
                    control: 'legends',
                    active: false
                });
            }
        },
        closeGeoChart() {
            this.$store.dispatch('setMapToolAction', {
                tool: 'geoprocessing',
                action: 'cleanResults',
                data: {}
            });
        }
    }
}
</script>

.data-container {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
z-index: 5000;
pointer-events: none;
}

/* Re-enable pointer events for children */
.data-container > * {
pointer-events: auto;
}